<template>
  <div class="duplicate-container">
    <div class="title">
      {{ $t(`${i18nPrefix}.title.duplicateTitle`) }}
    </div>
    <div class="duplicate-info">
      <div v-for="(item, index) in orderCandidateList" class="duplicate-item" :key="index" @click="viewCandidate(item)">
        <el-avatar class="avatar-container" :size="60" :src="$DjangoBaseUrl(item.photo)"></el-avatar>
        <div class="info">
          <div class="info-item name">{{ item.name }}</div>
          <div class="info-item id">
            <span class="label">ID: </span>
            <span class="content">{{ item.candidate_id }}</span>
          </div>
          <div v-if="getI18nPropertyValue(item, 'location_cn', 'location')" class="info-item location">
            {{ getI18nPropertyValue(item, 'location_cn', 'location') }}
          </div>
          <a class="info-item email" :title="item.email_address" :href="`mailTo:${item.email_address}`" @click.stop>{{ item.email_address }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getI18nPropertyValue } from '@/i18n'
import _ from 'lodash'

export default {
  props: {
    duplicateCandidateList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      getI18nPropertyValue
    }
  },
  computed: {
    jobId () {
      return this.$route.params.jobId
    },
    orderCandidateList () {
      if (!this.jobId) {
        return this.duplicateCandidateList
      }
      return _.sortBy(this.duplicateCandidateList, (candidate) => {
        if (_.includes(candidate.job_ids, Number(this.jobId))) {
          return -1
        }
        return 0
      })
    }
  },
  created () {

  },
  methods: {
    viewCandidate (application) {
      const applicationId = application.application_id
      const candidateId = application.candidate_id
      const jobId = application.job_id
      this.$emit('openDetail', { applicationId, candidateId, jobId })
    }
  }
}
</script>
<style lang='scss' scoped>
.duplicate-container {
  .title {
    padding-left: 10px;
    font-weight: bold;
    padding-bottom: 7px;
  }

  .duplicate-info {
    max-height: 320px;
    padding: 0 5px;
    overflow: auto;

    .duplicate-item {
      display: flex;
      padding: 10px;
      border-top: 1px solid #F0F0F0;
      cursor: pointer;

      .info {
        flex: 1;
        padding-left: 15px;

        .info-item {
          font-size: 12px;
          color: #0096cc;
          margin-top: 6px;

          &.name {
            font-weight: bold;
            margin-top: 0;
          }

          &.location {
            color: #606266;
          }

          &.email {
            display: block;
            overflow: hidden;
            max-width: 150px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
